import { Box, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@material-ui/core";
import { AddAlert } from "@material-ui/icons";
import keyBy from "lodash/keyBy";
import React, { useState } from "react";
import { Button, Datagrid, FunctionField, ListContextProvider, Pagination, TextField } from "react-admin";
import Separator from "../../../src/Components/Separator/Separator";
import { AircraftUtilizationTempCreateDto } from "./Constant/AircraftUtilizationModels";

export const ImportExcelInformationDialog = props => {
  const { openPopup, setOpenPopup, setLoading, tempData, notify, refresh, dataProvider } = props;
  const [page, setPage] = useState(1);
  const perPage = 10;

  const toInsert = tempData?.filter((r: AircraftUtilizationTempCreateDto) => r.isSuccess && !r.isUpdate).length ?? 0;
  const toUpdate = tempData?.filter((r: AircraftUtilizationTempCreateDto) => r.isSuccess && r.isUpdate).length ?? 0;
  const hasErrors = tempData?.filter((r: AircraftUtilizationTempCreateDto) => !r.isSuccess).length ?? 0;
  const hasValidRecords = toInsert + toUpdate > 0;

  const handleClose = () => setOpenPopup(false);

  const handleClickSubmit = () => {
    setOpenPopup(false);
    setLoading(true);
    if (!hasValidRecords) {
      setLoading(false);
      return;
    }
    sendExcelImportData(tempData);
  };

  const sendExcelImportData = (data: any[]) => {
    dataProvider
      .postAircraftUtilizationBulkCreate(data)
      .then(response => {
        if (response.data === true) {
          notify("Success", "info");
          refresh();
        } else {
          notify("Unknown Error", "info");
        }
        setLoading(false);
      })
      .catch(error => {
        notify(`Failed: ${error.message}`, "error");
        setLoading(false);
      });
  };

  const GetTempData = () => {
    return tempData?.slice?.((page - 1) * perPage, perPage * page);
  };

  const getStatusChip = (record: AircraftUtilizationTempCreateDto) => {
    if (record.successMessage === "Success") {
      return <Chip label="Will Be Inserted" style={{ backgroundColor: "#4caf50", color: "white" }} size="small" />;
    }
    if (record.successMessage === "WillBeUpdated") {
      return <Chip label="Will Be Updated" style={{ backgroundColor: "#ff9800", color: "white" }} size="small" />;
    }
    return (
      <Chip label={record.description || "Error"} style={{ backgroundColor: "#f44336", color: "white" }} size="small" />
    );
  };

  return (
    <Dialog open={openPopup} onClose={handleClose} fullWidth={true} maxWidth={"lg"}>
      <DialogTitle id="alert-dialog-title">{"Excel Import Report"}</DialogTitle>
      <Divider />
      <Separator />
      <Chip
        key={999999}
        color="primary"
        variant="outlined"
        label="Records with errors will not be processed. Existing records will be updated."
        style={{ margin: "auto" }}
        icon={<AddAlert />}
      />
      <Separator />
      <Box display="flex" justifyContent="center" style={{ gap: 8, padding: "0 16px" }}>
        <Chip label={`✅ ${toInsert} will be inserted`} style={{ backgroundColor: "#4caf50", color: "white" }} />
        <Chip label={`🔄 ${toUpdate} will be updated`} style={{ backgroundColor: "#ff9800", color: "white" }} />
        <Chip
          label={`❌ ${hasErrors} errors (will not be processed)`}
          style={{ backgroundColor: "#f44336", color: "white" }}
        />
      </Box>
      <DialogContent>
        <ListContextProvider
          value={{
            data: keyBy(GetTempData() ?? [], "id"),
            ids: GetTempData()?.map?.(({ id }) => id),
            currentSort: { field: "id", order: "ASC" },
          }}
        >
          <Datagrid optimized hasBulkActions={false}>
            <TextField source="acReg" label="Ac Reg" />
            <TextField source="periodYear" label="Period Year" />
            <TextField source="periodMonth" label="Period Month" />
            <TextField source="flightCycle" label="Flight Cycle" />
            <TextField source="flightHour" label="Flight Hour" />
            <TextField source="flightMinute" label="Flight Minute" />
            <FunctionField
              label="Status"
              render={record => getStatusChip(record as AircraftUtilizationTempCreateDto)}
            />
          </Datagrid>
          <Pagination
            //@ts-ignore
            page={page}
            perPage={perPage}
            setPage={setPage}
            total={tempData.length}
          />
        </ListContextProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} label="Cancel" />
        <Button onClick={handleClickSubmit} label="Save" disabled={!hasValidRecords} />
      </DialogActions>
    </Dialog>
  );
};
